export function isRefusedRequest(error: unknown): boolean {
  const status = (error as { response?: { status?: unknown } })?.response?.status;
  return typeof status === 'number' && status >= 400 && status < 500;
}
